export default __webpack_public_path__ + "fonts/WaterletHandFill-Regular.eot";